import { createContext, useContext } from "react";

export const AppActionsContext = createContext(null);

export function useAppActions() {
  return useContext(AppActionsContext);
}
